import * as _ from "lodash";
import * as moment from "moment";
import { STORAGE_KEYS } from "./constant";

export const toEZDate = (dbDate) => moment(dbDate).utcOffset(8).format("YYYY-MM-DD");

export const toJsDate = (dbDate, format = "YYYY-MM-DD HH:mm:ss") => moment(new Date(dbDate)).format(format);

export const mysqlDate = {
  toEZDate,
  toJsDate
};

export const trimAll = (obj) => {
  const result = {};
  for (let key in obj) {
    if (typeof obj[key] === "object") {
      result[key] = trimAll(obj[key]);
    } else if (typeof obj[key] === "string") {
      result[key] = String(obj[key]).replace(/ /g, "");
    } else {
      result[key] = obj[key];
    }
  }
  return result;
};

function separateNumberAndText(string) {
  let number = [],
    text = [],
    result = "",
    type = "";
  string.split("").forEach((s) => {
    if (!isNaN(Number(s))) {
      if (!type || type === "number") {
        result += s;
      } else {
        text.push(result);
        result = s;
      }
      type = "number";
    } else {
      if (!type || type === "string") {
        result += s;
      } else {
        number.push(result);
        result = s;
      }
      type = "string";
    }
  });
  if (type === "string") text.push(result);
  else number.push(result);
  return { number, text };
}
/**
 * table schema -> table width
 * @param {object} json
 */
export const calTableX = (json) =>
  _.reduce(
    json,
    (res, val) => {
      if (typeof val.width === "number") return res + (val.width || 0);
      else if (typeof val.width === "string") {
        const { number, text } = separateNumberAndText(val.width);
        const num = number[0];
        const unit = text[0];
        switch (unit) {
          case "px":
            return res + (num || 0);
          case "em":
          case "rem":
            return res + (num || 0) * 16;
          default:
            return res;
        }
      } else {
        return res;
      }
    },
    0
  );
/**
 * return true if arr1 === arr2
 * @param {Array} arr1
 * @param {Array} arr2
 */
export const compareArr = (arr1 = [], arr2 = []) => {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) throw Error("arr type is WRONG!");

  return JSON.stringify(objToSortString(arr2)) === JSON.stringify(objToSortString(arr1));
};

export const objToSortString = (unordered = {}) => {
  let ordered = {};
  Object.keys(unordered)
    .sort()
    .forEach((key) => {
      let value = unordered[key];
      if (typeof value === "object") {
        value = objToSortString(unordered[key]);
      }
      ordered[key] = value;
    });
  return ordered;
};

export function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

export function parseObjToArrObj(obj) {
  let array = [];
  delete obj.tags;
  Object.keys(obj).forEach((k) => {
    let innerObj = {};
    if (_.isEmpty(obj[k])) delete obj[k];
    else {
      innerObj[k] = obj[k];
      array.push(innerObj);
    }
  });

  return array;
}

export const isNil = (x) => x === null || x === undefined;

export const handleResp = async (dispatch, action, param) => {
  try {
    const data = await (dispatch ? dispatch(action(param)) : action(param));
    const error = _.get(data, "error") || _.get(data, "data.error");
    const result = _.get(data, "data.data") || _.get(data, "data") || data;

    if (data.err || error)
      return {
        success: false,
        ...error,
        error: data.message || _.get(error, "msg") || "錯誤",
        code: _.get(error, "code") || data.status
      };
    else return { success: true, data: result };
  } catch (error) {
    console.log(error);
    return { success: false, error: "錯誤" };
  }
};

export function deleteCookie(key) {
  document.cookie = `${key}=''; expires=Thu, 01 Jan 1970 00:00:01 GMT`;
}
export function setCookie({ key, value, expireTime }) {
  document.cookie = `${key}=${value}; expires=${new Date(expireTime).toGMTString()}`;
}

export function getCookie(key) {
  const cookie = document.cookie.split("; ").reduce((obj, cookie) => {
    const key = cookie.split("=")[0];
    const value = cookie.split(`${key}=`)[1];
    obj[key] = value;
    return obj;
  }, {});
  return cookie[key] || "";
}

export const imgDefaultHeaders = () => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const headers = {
    "Content-Type": "multipart/form-data",
    "X-Access-Token": token
  };
  return headers;
};

export const defaultHeaders = () => {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  const headers = {
    "Content-Type": "application/json",
    "X-Access-Token": token
  };
  return headers;
};
